
export default function FourError() {
  return (
    <div style={{margin:"auto", width:'50%'}}>Something is wrong</div>
  )
}
